/* ============================================================================
   Peel-Off Jelly Mask LP. No dependencies.

   Everything priced on this page comes from the server-rendered block in
   #jm-data, which is built from the live product record:
     base  = variant.price
     pro   = the dollar figure parsed out of custom.pro_variant_price,
             with any active sale discount applied on top
   There is no hardcoded discount and no hardcoded price. If the metafield is
   missing for a variant, pro falls back to base (no discount) rather than
   inventing one.

   The cart drawer renders the REAL Shopify cart read from /cart.js, so the
   subtotal it shows is the subtotal checkout will charge. The one exception
   is the pro preview: with the toggle on, our own variants are re-priced for
   display and #drawer-pro discloses that checkout bills list price.
   ========================================================================== */
(function () {
  'use strict';

  var dataEl = document.getElementById('jm-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  var VARIANTS = DATA.variants;
  var PRODUCT_URL = DATA.productUrl;
  var SACHET_IMG = DATA.sachetImage;

  /* Move the fixed-position furniture to <body>. Blockshop wraps templates in
     a transition container, and a transformed ancestor would make position:fixed
     resolve against that container instead of the viewport. */
  var portal = document.getElementById('jm-portal');
  if (portal && portal.parentNode !== document.body) document.body.appendChild(portal);

  var state = { charge: 20, pro: false, selected: 12, rev: 0, ba: 0 };
  var cart = { items: [], item_count: 0, total_price: 0 };

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + n.toFixed(2); };
  var whole = function (n) { return '$' + Math.round(n); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var KEYS = ['1', '6', '12'];
  function V(k) { return VARIANTS[String(k)]; }

  /* The headline percentage is derived, never typed. It reads off the 12-pack,
     which is the pack this page is built around. */
  var PCT = (function () {
    /* Prefer the 12-pack, the pack this page is built around. Fall back to the best real
       saving so a partially-covered price list cannot render "Pro, 0% off". */
    if (proSavesOn(V(12))) return Math.round((1 - V(12).pro / V(12).base) * 100);
    var best = 0;
    KEYS.forEach(function (k) {
      var v = V(k);
      if (proSavesOn(v)) best = Math.max(best, Math.round((1 - v.pro / v.base) * 100));
    });
    return best;
  })();
  (function warnIfUneven() {
    var seen = [];
    KEYS.forEach(function (k) {
      var v = V(k);
      if (v && v.base) seen.push(Math.round((1 - v.pro / v.base) * 100));
    });
    var uneven = seen.some(function (p) { return p !== seen[0]; });
    if (PRO_SAVES && uneven && window.console && console.warn) {
      console.warn('[jelly-mask-lp] custom.pro_variant_price implies different discounts per variant',
                   seen, '- the displayed percentage uses the 12-pack.');
    }
  })();

  /* Shopify serves a logged-in customer their OWN price as variant.price, and this store
     runs more than one price list: Starpil Pro Main (-20%, which is what
     custom.pro_variant_price encodes) and Starpil Select (-35%, which is cheaper still).
     So the pro preview is only honest when the metafield price actually beats what this
     visitor already pays:
       anonymous / retail   base >  pro   show the preview  (this is the paid-traffic case)
       Pro customer         base == pro   nothing to preview
       Select customer      base <  pro   they already do better; never offer them worse
     Without this a Select customer sees "Pro, -23% off" and a toggle that raises the price. */
  function proSavesOn(v) { return v && v.base > 0 && (v.base - v.pro) > 0.005; }
  var PRO_SAVES = KEYS.some(function (k) { return proSavesOn(V(k)); });

  function priceOf(k) { var v = V(k); return state.pro ? v.pro : v.base; }
  function unitOf(k)  { var v = V(k); return priceOf(k) / v.count; }
  function soldOut(k) { var v = V(k); return !!v && v.available === false; }
  function notifyUrl(k) { return PRODUCT_URL + '?variant=' + V(k).id; }
  function chargeText() { var c = state.charge; return '$' + (c % 1 === 0 ? c : c.toFixed(2)); }

  /* One verb for one action. 'Add the 1 sachet' is not English, so the label is a map. */
  var CTA_LABEL = { 1: 'Add one sachet', 6: 'Add the 6-pack', 12: 'Add the 12-pack' };
  /* The sticky bar is narrow, so it gets its own short caption and keeps 'Email me'
     rather than the full notify label. */
  var STICKY_CAP = { 1: '1 sachet', 6: '6-pack', 12: '12-pack' };
  var NOTIFY_LABEL = 'Notify me when it’s back';

  /* ---------- render ---------- */
  function render() {
    var c = state.charge, sel = state.selected, v = V(sel);
    var b1 = priceOf(1), b6 = priceOf(6), b12 = priceOf(12);
    var bu6 = unitOf(6), bu12 = unitOf(12);
    var baseUnit = { 1: b1, 6: bu6, 12: bu12 };

    var map = {
      '[data-charge]': chargeText(),
      '[data-pct]': PCT + '%',
      '[data-price-1]': money(b1),
      '[data-price-6]': money(b6),
      '[data-price-12]': money(b12),
      '[data-unit-6]': money(bu6),
      '[data-unit-12]': money(bu12),
      '[data-keep-1]': money(c - b1),
      '[data-keep-6]': money(c - bu6),
      '[data-keep-12]': money(c - bu12),
      '[data-return-1]': whole(c - b1),
      '[data-return-6]': whole((c - bu6) * 6),
      '[data-return-12]': whole((c - bu12) * 12),

      '[data-sel-name]': v.name,
      '[data-sel-meta]': money(priceOf(sel)) + ' · ' + money(baseUnit[sel]) + ' per sachet · ' + (v.count === 1 ? '1 treatment' : v.count + ' treatments'),
      '[data-sel-keep]': money(c - baseUnit[sel]),
      '[data-sel-return]': whole((c - baseUnit[sel]) * v.count)
    };
    Object.keys(map).forEach(function (k) {
      $$(k).forEach(function (el) { el.textContent = map[k]; });
    });

    $('#pro-strip').hidden = !PRO_SAVES || !state.pro;
    $$('.tier button').forEach(function (b) {
      b.setAttribute('aria-checked', String((b.dataset.tier === 'pro') === state.pro));
    });

    /* rows: selection state, live stock, and a real sold-out state.
       No greyed rows: a sold-out row still routes to the Rez notify capture. */
    $$('.js-row').forEach(function (b) {
      var k = Number(b.dataset.variant);
      b.setAttribute('aria-checked', String(k === sel));
      var right = b.querySelector('.right');
      var st = right.querySelector('[data-stock]');
      if (soldOut(k)) {
        if (!st) { st = document.createElement('span'); st.className = 'stock'; st.setAttribute('data-stock', ''); right.appendChild(st); }
        st.textContent = 'Sold out. Notify me';
      } else if (st) {
        st.textContent = (V(k).stock !== null && V(k).stock > 0) ? V(k).stock + ' packs in stock' : '';
      }
    });

    var cta = $('#sel-cta');
    cta.dataset.variant = String(sel);
    cta.textContent = soldOut(sel) ? NOTIFY_LABEL : CTA_LABEL[sel];

    /* The bar follows the pack chosen in block 09. The default is still the 12-pack, so the
       anchor is unchanged, but the bar must never contradict a choice she just made. */
    var stickyCta = $('#sticky-cta');
    stickyCta.dataset.variant = String(sel);
    stickyCta.textContent = soldOut(sel) ? 'Email me' : CTA_LABEL[sel];
    $('[data-sticky-cap]').textContent = STICKY_CAP[sel];
    $('[data-sticky-sub]').textContent = v.count === 1
      ? money(priceOf(sel))
      : money(priceOf(sel)) + ', ' + money(unitOf(sel)) + ' a sachet';

    renderCart();
  }

  /* ---------- cart ---------- */
  function ourKeyFor(variantId) {
    for (var i = 0; i < KEYS.length; i++) if (V(KEYS[i]).id === variantId) return KEYS[i];
    return null;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderCart(); })
      .catch(function () { /* leave the last known cart on screen */ });
  }

  function renderCart() {
    var box = $('#drawer-lines');
    box.innerHTML = '';
    var items = cart.items || [];
    var sub = 0, sachets = 0;

    if (!items.length) {
      box.innerHTML = '<p class="body">Nothing in the cart yet. The 12-pack is the one that puts the most back.</p>';
    }

    items.forEach(function (item, i) {
      var k = ourKeyFor(item.variant_id);
      var real = item.final_price / 100;                       /* per unit, after line discounts */
      var each = (k && state.pro) ? V(k).pro : real;
      var qty  = item.quantity;
      sub += each * qty;
      if (k) sachets += V(k).count * qty;

      var nm = k ? V(k).name
                 : item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' / ' + item.variant_title : '');
      var per = k ? money(each / V(k).count) + ' per sachet' : money(each) + ' each';
      var img = k ? SACHET_IMG : (item.image || SACHET_IMG);

      var row = document.createElement('div');
      row.className = 'line';
      row.innerHTML =
        '<span class="thumb"><img src="' + esc(img) + '" alt=""></span>' +
        '<div class="info"><p class="nm">' + esc(nm) + '</p>' +
        '<p class="ea">' + per + '</p>' +
        '<div class="qty">' +
        '<button type="button" data-step="-1" data-line="' + (i + 1) + '" aria-label="Remove one ' + esc(nm) + '">&minus;</button>' +
        '<span>' + qty + '</span>' +
        '<button type="button" data-step="1" data-line="' + (i + 1) + '" aria-label="Add one more ' + esc(nm) + '">+</button>' +
        '</div></div>' +
        '<p class="lt">' + money(each * qty) + '</p>';
      box.appendChild(row);
    });

    /* With pro off this is Shopify's own total, so the drawer cannot drift from checkout. */
    var displaySub = state.pro ? sub : (cart.total_price != null ? cart.total_price / 100 : sub);
    $('#drawer-subtotal').textContent = money(displaySub);

    $('#drawer-note').textContent = sachets
      ? sachets + ' treatments. At ' + chargeText() + ' each that is ' + whole(state.charge * sachets) + ' of service revenue.'
      : 'Add a pack to see what it puts back.';

    /* Disclosure. Without this the drawer quotes a price checkout will not honour.
       Suppressed when the visitor is already on pro pricing, where it would be false. */
    $('#drawer-pro').hidden = !PRO_SAVES || !state.pro;

    var n = cart.item_count || 0;
    var badge = $('#cart-count');
    badge.textContent = n;
    badge.hidden = n === 0;
    $('#cart-open').setAttribute('aria-label', n ? 'Your cart, ' + n + ' items' : 'Your cart, empty');
  }

  function toast(msg) {
    var t = $('#toast');
    t.querySelector('p').textContent = msg;
    t.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.hidden = true; }, 2300);
  }

  /* ---------- add to cart ----------
     items[] is the documented shape for /cart/add.js; a bare top-level id
     silently wins over it, so the two forms are never mixed. If the POST fails
     we fall back to the GET route rather than swallowing it, because a button
     that looks like it worked and did not is worse than a reload. */
  function add(k) {
    if (soldOut(k)) { window.location = notifyUrl(k); return; }
    var v = V(k);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart/add.js returned ' + r.status); }
      return r.json();
    }).then(function () {
      return fetchCart();
    }).then(function () {
      $('#drawer').setAttribute('data-open', '');
      toast('Added: ' + v.name);
    }).catch(function () {
      window.location = '/cart/add?id=' + v.id + '&quantity=1';
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderCart(); })
      .catch(function () { fetchCart(); });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.js-add');
    if (addBtn) { add(Number(addBtn.dataset.variant)); return; }

    var row = e.target.closest('.js-row');
    if (row) { state.selected = Number(row.dataset.variant); render(); return; }

    var step = e.target.closest('[data-step]');
    if (step) {
      var line = Number(step.dataset.line);
      var item = (cart.items || [])[line - 1];
      if (item) changeLine(line, item.quantity + Number(step.dataset.step));
      return;
    }

    var play = e.target.closest('.js-play');
    if (play) {
      var fig = play.closest('.js-video');
      var video = fig.querySelector('video');
      var src = video.querySelector('source').getAttribute('src');
      if (!src) { toast('Video file not uploaded yet'); return; }
      fig.querySelector('img').hidden = true;
      play.hidden = true;
      video.hidden = false;
      video.play();
      return;
    }

    var tier = e.target.closest('.tier button');
    if (tier) { state.pro = tier.dataset.tier === 'pro'; render(); if (state.pro) toast('Pro pricing on'); return; }

    var faqBtn = e.target.closest('#faq button');
    if (faqBtn) {
      var body = faqBtn.closest('h3').nextElementSibling;
      var open = faqBtn.getAttribute('aria-expanded') === 'true';
      $$('#faq button').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.querySelector('.sign').textContent = '+';
        b.closest('h3').nextElementSibling.hidden = true;
      });
      if (!open) {
        faqBtn.setAttribute('aria-expanded', 'true');
        faqBtn.querySelector('.sign').textContent = '−';
        body.hidden = false;
      }
      return;
    }

    if (e.target.closest('#cart-open')) { $('#drawer').setAttribute('data-open', ''); return; }
    if (e.target.closest('#drawer-close') || e.target.closest('#drawer-scrim')) { $('#drawer').removeAttribute('data-open'); return; }
    if (e.target.closest('#checkout')) { window.location = '/checkout'; return; }
  });

  $('#charge-up').addEventListener('click', function () { state.charge = Math.min(60, state.charge + 1); render(); });
  $('#charge-down').addEventListener('click', function () { state.charge = Math.max(10, state.charge - 1); render(); });

  /* carousels: index in state is the only source of truth.
     Pixel offsets, not percentages: a percentage translate does not resolve
     reliably against a flex track and desyncs the dots from the visible frame. */
  function carousel(trackId, dotsId, max, key, labelId) {
    var track = $('#' + trackId), dots = $$('#' + dotsId + ' span');
    function paint() {
      var w = track.parentElement.clientWidth;
      track.style.transform = 'translateX(' + (-state[key] * w) + 'px)';
      dots.forEach(function (d, i) { if (i === state[key]) d.setAttribute('data-on', ''); else d.removeAttribute('data-on'); });
      if (labelId) $('#' + labelId).textContent = (state[key] + 1) + ' of ' + max;
    }
    window.addEventListener('resize', paint);
    paint();
    return function (delta) {
      state[key] = Math.max(0, Math.min(max - 1, state[key] + delta));
      paint();
    };
  }
  var stepRev = carousel('rev-track', 'rev-dots', 3, 'rev', null);
  var stepBa  = carousel('ba-track', 'ba-dots', 4, 'ba', 'ba-label');
  $('#rev-prev').addEventListener('click', function () { stepRev(-1); });
  $('#rev-next').addEventListener('click', function () { stepRev(1); });
  $('#ba-prev').addEventListener('click', function () { stepBa(-1); });
  $('#ba-next').addEventListener('click', function () { stepBa(1); });

  /* sticky bar: appears once the hero sentinel passes the top */
  var fold = $('#fold'), sticky = $('#sticky');
  function onScroll() {
    if (fold.getBoundingClientRect().top < 0) sticky.setAttribute('data-on', '');
    else sticky.removeAttribute('data-on');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* five-star rows. Gold, per the handoff: gold is ours. */
  var STAR = '<svg width="15" height="15" viewBox="0 0 24 24" fill="#806331" aria-hidden="true">' +
             '<path d="M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.9 6.19 20.9 7.3 14.43 2.6 9.85l6.5-.95z"/></svg>';
  $$('.stars').forEach(function (el) { el.innerHTML = new Array(6).join(STAR); });

  if (!PRO_SAVES) {
    var tierEl = $('.tier');
    if (tierEl) tierEl.hidden = true;
    $$('.js-pro-pitch').forEach(function (el) { el.hidden = true; });
  }

  render();
  onScroll();
  fetchCart();
})();
